import { ComponentBase } from "@tblabs/truffle";


export class Section extends ComponentBase<HTMLElement>
{
    constructor(klass: string)
    {
        super("section");

        this.Class(klass);
    }
}
